module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-header', {
    attrs: {
      "title": "通信录应用",
      "fixed": ""
    }
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "left"
  }, [_vm._v("返回")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/add"
    },
    slot: "right"
  }, [_c('span', {
    staticClass: "iconfont icon-plus"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-47116a0b!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 26
// module chunks = 0